import { render } from "./WorkcampTimeline.vue?vue&type=template&id=1f0f9a2c"
import script from "./WorkcampTimeline.vue?vue&type=script&lang=js"
export * from "./WorkcampTimeline.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\fdm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QVideo from 'quasar/src/components/video/QVideo.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVideo,QCard,QCardSection});
